import { BaseClusterRenderer, MarkerTypeConfig } from "../../interfaces/maps/base-cluster-renderer";

export class DefaultClusterRender extends BaseClusterRenderer {
  protected override getMarkerTypesConfig(): { [key: string]: MarkerTypeConfig; } {
    return {
      'default': { color: '#ee2737', pulsate: true },
    }
  }

  protected override getMarkerType(marker: google.maps.marker.AdvancedMarkerElement): string | null {
    return 'default';
  }
}